import React from "react";
import { Router, Route } from "react-router";
import App from "./page/index";
import Loading from "./page/loading";
import Login from "./page/login";
import Register from "./page/register";
import ForgotPassword from "./page/forgot-password";
import NotFound from "./page/not-found";
import InAndOutWard from "./page/in-and-out-ward";
import InternalParcel from "./page/internal-parcel";
import ExternalParcel from "./page/external-parcel";
import Carrying from "./page/carrying";
import InAndOutList from "./page/InAndOut/in-and-out-list";
import CardType from "./page/InAndOut/card-type";
import Admin from "./page/Admin/admin";
import RoleWeb from "./page/Admin/role-web";
import RoleMobile from "./page/Admin/role-mobile";
import User from "./page/user";

import Service from "./page/Public/service";
import QRCode from "./page/Service/qrcode";
import ServiceList from "./page/Service/service";
import Setting from "./page/Service/setting";

import "./global.js";

const Routes = (props) => (
  <Router {...props}>
    <Route path="/index" component={App} />
    <Route path="/" component={Loading} />
    <Route path="/login" component={Login} />
    <Route path="/register" component={Register} />
    <Route path="/forgot-password" component={ForgotPassword} />
    <Route path="/in-and-out-ward" component={InAndOutWard} />
    <Route path="/internal-parcel" component={InternalParcel} />
    <Route path="/external-parcel" component={ExternalParcel} />
    <Route path="/carrying" component={Carrying} />
    <Route path="/in-and-out-list" component={InAndOutList} />
    <Route path="/card-type" component={CardType} />
    <Route path="/admin" component={Admin} />
    <Route path="/role-web" component={RoleWeb} />
    <Route path="/role-mobile" component={RoleMobile} />
    <Route path="/user" component={User} />

    <Route path="/qr-code" component={QRCode} />
    <Route path="/service-list" component={ServiceList} />
    <Route path="/service-setting" component={Setting} />

    <Route path="/service" component={Service} />
    <Route path="*" component={NotFound} />
  </Router>
);

export default Routes;
